import { UserDto } from '@fleet-beat/core';
import { VehicleDto } from '../assets';

export interface LogDto {
  driver?: UserDto;
  coDriver?: UserDto;
  distance?: string;
  trucks?: VehicleDto[];
  shippingDocs?: string[];
  trailerNumbers?: string[];
  signature?: string;
}
